import axios from 'axios';



export default axios.create({
    baseURL: 'https://www.p4life-rk.cz/wp-json/wp/v2/',

});